import { Center, Stack, Loader, Text, Paper, Box } from '@mantine/core';
import { IconCloud } from '@tabler/icons-react';

interface FogLoadingOverlayProps {
  message?: string;
}

export function FogLoadingOverlay({ message = 'Connecting to FOG Server...' }: FogLoadingOverlayProps) {
  return (
    <Center h="60vh">
      <Paper
        p="xl"
        radius="lg"
        withBorder
        style={{
          background: 'var(--mantine-color-dark-7)',
          borderColor: 'var(--mantine-color-dark-5)',
        }}
      >
        <Stack align="center" gap="lg">
          <Box
            style={{
              animation: 'fogPulse 2s ease-in-out infinite',
            }}
          >
            <IconCloud size={48} style={{ color: 'var(--mantine-color-blue-5)' }} />
          </Box>
          <Loader size="lg" type="dots" color="blue" />
          <Text c="dimmed" size="sm" ta="center">
            {message}
          </Text>
        </Stack>
      </Paper>
      <style>{`
        @keyframes fogPulse {
          0%, 100% {
            opacity: 0.6;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
        }
      `}</style>
    </Center>
  );
}
